import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.use_manual_pricing = this.element.querySelector("#claim_use_manual_pricing");
    this.goodbill_allowed_amount = this.element.querySelector("#claim_goodbill_allowed_amount");
    this.goodbill_allowed_amount_block = this.element.querySelector("#claim_goodbill_allowed_amount_block");

    this.refreshAllowedAmountInput();
    this.use_manual_pricing.addEventListener("change", this.refreshAllowedAmountInput.bind(this));
  }

  refreshAllowedAmountInput() {
    if (this.use_manual_pricing.checked) {
      this.goodbill_allowed_amount_block.classList.remove("hidden");
      this.goodbill_allowed_amount.removeAttribute("disabled");
    } else {
      this.goodbill_allowed_amount_block.classList.add("hidden");
      this.goodbill_allowed_amount.setAttribute("disabled", "disabled");
    }
  }
}